/**
 * Apply serve-injected S3 prefix so lazy-loaded chunks use CDN, not the pod origin.
 * Must assign `__webpack_public_path__` (webpack API) — setting only `window.__webpack_public_path__` is not enough.
 */
const { resolveWebpackPublicPath } = require('./resolve-webpack-public-path');

const fromWindow = typeof window !== 'undefined' ? window.__webpack_public_path__ : undefined;

// Webpack replaces this global; assignment is intentional (SSAT-15641 CDN lazy chunks).
// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = resolveWebpackPublicPath(fromWindow);
